import { toast } from "react-toastify";
//API for TimeLines
import { TimelineConstants } from "../_constants";
import { TimelineService } from "../_services";
// import { TimelineService } from '../_services';

export const TimelineActions = {
  loadFromChronicle,
  newTimeline,
  updateTimeline,
  deleteTimeline,
};

function loadFromChronicle(payload) {
  return {
    type: TimelineConstants.POPULATE_TIMELINES,
    payload,
  };
}

function newTimeline(params) {
  return (dispatch) => {
    dispatch(request(params));

    return TimelineService.newTimeline(params).then(
      (timeline) => {
        toast.success(`Successfully created Timeline "${timeline.title}"`);
        // console.log('CHRONOS: New Timeline Created');
        dispatch(success(timeline));
        return timeline;
      },
      (error) => {
        const message = error.toString();
        console.log(`[Chronos] Error - Create Timeline: `, error);
        toast.error(`Unable to create new Timeline "${params.title}"`);
        // console.warn(error.toString());
        dispatch(failure(message));
      }
    );
  };

  function request(params) {
    return {
      type: TimelineConstants.CREATE_REQUEST,
      params,
    };
  }

  function success(timeline) {
    return {
      type: TimelineConstants.CREATE_SUCCESS,
      payload: timeline,
    };
  }

  function failure(error) {
    return {
      type: TimelineConstants.CREATE_FAILURE,
      error,
    };
  }
}

function updateTimeline(timeline) {
  return (dispatch) => {
    dispatch(request(timeline));

    return TimelineService.updateTimeline(timeline).then(
      (timeline) => {
        toast.success(`Timeline "${timeline.title}" successfully updated!`);
        dispatch(success(timeline));
      },
      (error) => {
        const message = error.toString();
        console.log(`[Chronos] Error - Update Timeline: `, error);
        toast.error(
          "Unable to update Timeline due to an error. Please try again."
        );
        dispatch(failure(message));
      }
    );
  };

  function request(params) {
    return {
      type: TimelineConstants.UPDATE_REQUEST,
      params,
    };
  }
  function success(timeline) {
    return {
      type: TimelineConstants.UPDATE_SUCCESS,
      payload: timeline,
    };
  }
  function failure(error) {
    return {
      type: TimelineConstants.UPDATE_FAILURE,
      error,
    };
  }
}

function deleteTimeline(timelineID) {
  return (dispatch) => {
    dispatch(request(timelineID));

    return TimelineService.deleteTimeline(timelineID).then(
      () => {
        toast.success("Timeline successfully deleted!");
        dispatch(success(timelineID));
      },
      (error) => {
        const message = error.toString();
        console.log(`[Chronos] Error - Delete Timeline: `, error);
        toast.error(`Unable to delete Timeline.`);
        dispatch(failure(message));
      }
    );
  };

  function request(timelineID) {
    return {
      type: TimelineConstants.DELETE_REQUEST,
      params: timelineID,
    };
  }
  function success(timelineID) {
    return {
      type: TimelineConstants.DELETE_SUCCESS,
      payload: timelineID,
    };
  }

  function failure(error) {
    return {
      type: TimelineConstants.DELETE_FAILURE,
      error,
    };
  }
}
